import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "text-xl font-semibold text-center outline-none" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "relative flex-shrink-0 bg-gray-100 rounded overflow-hidden pt-6 pb-1 px-5 cursor-default whitespace-nowrap" }
const _hoisted_5 = {
  class: "absolute top-1.5 left-5 text-gray-400",
  style: {"font-size":"0.8125rem"}
}
const _hoisted_6 = { class: "text-sm text-dark-gray-600" }
const _hoisted_7 = { class: "relative flex-1" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "absolute z-10 top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto"
}
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "grid grid-cols-[2fr_1.5fr_1fr_1fr_2rem_2rem] gap-x-3 px-6 pb-2 text-[0.9rem] text-gray-500" }
const _hoisted_14 = { class: "text-right text-primary-800 leading-tight" }
const _hoisted_15 = { class: "text-right text-primary-800 leading-tight" }
const _hoisted_16 = { class: "grid grid-cols-[2fr_1.5fr_1fr_1fr_2rem_2rem] items-center gap-x-3 px-6 py-4" }
const _hoisted_17 = { class: "text-[0.9rem] font-medium text-primary-800" }
const _hoisted_18 = { class: "text-[0.9rem] text-gray-500" }
const _hoisted_19 = { class: "text-right text-[0.9rem] text-gray-400" }
const _hoisted_20 = { class: "flex justify-end" }
const _hoisted_21 = {
  key: 1,
  class: "text-[0.9rem] text-gray-400"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "border-t border-gray-200 border-l-4 border-primary-300" }
const _hoisted_26 = {
  key: 0,
  class: "bg-gray-50"
}
const _hoisted_27 = { class: "grid grid-cols-[1fr_1fr_1fr_1fr_1fr] gap-x-3 px-6 py-2 border-b border-gray-200 text-xs text-gray-500" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right text-primary-800" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "grid grid-cols-[1fr_1fr_1fr_1fr_1fr] items-center gap-x-3 px-6 py-3" }
const _hoisted_33 = { class: "text-[0.9rem] text-gray-500" }
const _hoisted_34 = { class: "text-right text-[0.9rem] text-gray-500" }
const _hoisted_35 = { class: "text-right text-[0.9rem] text-gray-500" }
const _hoisted_36 = { class: "flex justify-end" }
const _hoisted_37 = { class: "text-right text-[0.9rem] font-medium text-primary-800" }
const _hoisted_38 = {
  key: 0,
  class: "flex items-center gap-2 px-6 py-2 bg-gray-50 border-b border-gray-200 text-xs"
}
const _hoisted_39 = { class: "text-gray-500 mr-1" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "flex items-center gap-1 px-6 py-2 bg-gray-50 border-b border-gray-200 text-amber-600 text-xs"
}
const _hoisted_43 = { class: "grid grid-cols-[2fr_1fr_1fr_1fr_1fr_2rem_2rem] gap-x-3 px-6 py-1.5 text-xs text-gray-500 bg-gray-50 border-b border-gray-200" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "text-right text-primary-800" }
const _hoisted_46 = { class: "text-right" }
const _hoisted_47 = { class: "text-right text-primary-800" }
const _hoisted_48 = { class: "pl-6 text-sm text-gray-600" }
const _hoisted_49 = { class: "text-right text-sm text-gray-400" }
const _hoisted_50 = { class: "flex justify-end" }
const _hoisted_51 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_52 = { class: "text-right text-sm text-gray-400" }
const _hoisted_53 = { class: "flex justify-end" }
const _hoisted_54 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_55 = { class: "bg-gray-50 border-t border-gray-200" }
const _hoisted_56 = { class: "grid grid-cols-[1fr_1fr_1fr_1fr] gap-x-3 px-6 pt-2 pb-1 text-xs text-gray-500" }
const _hoisted_57 = { class: "text-primary-800" }
const _hoisted_58 = { class: "text-primary-800" }
const _hoisted_59 = { class: "grid grid-cols-[1fr_1fr_1fr_1fr] gap-x-3 items-center px-6 pb-3" }
const _hoisted_60 = { class: "text-[0.9rem] text-gray-500" }
const _hoisted_61 = { class: "text-[0.9rem] text-gray-500" }
const _hoisted_62 = {
  key: 0,
  class: "grid grid-cols-[2fr_1.5fr_1fr_1fr_2rem_2rem] items-center gap-x-3 px-6 py-4 border-t-2 border-gray-300"
}
const _hoisted_63 = { class: "text-[0.9rem] font-semibold text-primary-800" }
const _hoisted_64 = { class: "text-right text-[0.9rem] font-semibold text-gray-500" }
const _hoisted_65 = { class: "text-right text-[0.9rem] font-semibold text-primary-800" }
const _hoisted_66 = {
  key: 2,
  class: "text-red-500 text-sm text-right"
}
const _hoisted_67 = { class: "flex items-center space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SimpleInput = _resolveComponent("SimpleInput")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_DeleteReconciliationConfirmationModal = _resolveComponent("DeleteReconciliationConfirmationModal")!
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.period')), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedFromDate) + " – " + _toDisplayString(_ctx.formattedToDate), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addSearch) = $event)),
          type: "text",
          placeholder: _ctx.$t('views.feed.reconciliations.newModal.registrationSummary.addFeedmixPlaceholder'),
          class: "w-full px-4 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 focus:outline-none focus:border-primary-800",
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddDropdown = true)),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddBlur && _ctx.onAddBlur(...args)))
        }, null, 40, _hoisted_8), [
          [_vModelText, _ctx.addSearch]
        ]),
        (_ctx.showAddDropdown && _ctx.filteredAvailableMixes.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableMixes, (mix) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: mix.id,
                  type: "button",
                  class: "w-full text-left px-4 py-2 text-[0.9rem] hover:bg-gray-50",
                  onMousedown: _withModifiers(($event: any) => (_ctx.addFeedMix(mix)), ["prevent"])
                }, _toDisplayString(mix.name), 41, _hoisted_10))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_Spinner, { class: "w-8 h-8" })
        ]))
      : (_ctx.summary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.name')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.type')), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.registeredConsumptionShort')) + ", kg ", 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualConsumptionShort')) + ", kg ", 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, null, -1))
            ]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.feedmix.id,
                  class: "rounded odd:bg-dark-gray-200"
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.feedmix.name), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.feed_type.name), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatNumber(item.consumption_over_period)), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.canEditFeedMix(item))
                        ? (_openBlock(), _createBlock(_component_SimpleInput, {
                            key: 0,
                            grouped: "",
                            value: _ctx.rowStates[item.feedmix.id].actualConsumption ?? '',
                            type: "number",
                            "background-color": "bg-white",
                            class: "w-24 text-right text-[0.9rem] font-medium text-primary-800 border border-gray-300 rounded",
                            onKeydown: _ctx.onNumberKeydown,
                            "onUpdate:value": ($event: any) => (_ctx.rowStates[item.feedmix.id].actualConsumption = ($event === '' || $event === null ? null : _ctx.toPositive($event)))
                          }, null, 8, ["value", "onKeydown", "onUpdate:value"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formatNumber(_ctx.getFeedMixDisplayActual(item))), 1))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "flex items-center justify-center",
                      onClick: ($event: any) => (_ctx.rowStates[item.feedmix.id].expanded = !_ctx.rowStates[item.feedmix.id].expanded)
                    }, [
                      _createVNode(_component_Icon, {
                        src: _ctx.IconSource.DropdownDark,
                        class: _normalizeClass(["w-5 h-5 transition-transform duration-200", { 'rotate-180': _ctx.rowStates[item.feedmix.id].expanded }])
                      }, null, 8, ["src", "class"])
                    ], 8, _hoisted_22),
                    (_ctx.rowStates[item.feedmix.id]?.isAdded)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "flex items-center justify-center text-gray-400 hover:text-red-500",
                          onClick: ($event: any) => (_ctx.removeRow(item))
                        }, [
                          _createVNode(_component_Icon, {
                            src: _ctx.IconSource.Close,
                            class: "w-5 h-5"
                          }, null, 8, ["src"])
                        ], 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "flex items-center justify-center text-gray-400 hover:text-gray-600",
                          onClick: ($event: any) => (_ctx.resetRow(item))
                        }, [
                          _createVNode(_component_Icon, {
                            src: _ctx.IconSource.RefreshActivities,
                            class: "w-5 h-5"
                          }, null, 8, ["src"])
                        ], 8, _hoisted_24))
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_25, [
                    (_ctx.isCompoundFeed(item))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.initialAmount')) + ", kg", 1),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.deliveredAmount')) + ", kg", 1),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.availableAmount')) + ", kg", 1),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.remainderAmount')) + ", kg", 1),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualAmount')) + ", kg", 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatNumber(item.initial_amount_from_preceding_period ?? 0)), 1),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formatNumber(item.delivered_in_period ?? 0)), 1),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.formatNumber(_ctx.getCompoundAvailable(item))), 1),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_SimpleInput, {
                                grouped: "",
                                value: _ctx.rowStates[item.feedmix.id].remainder ?? '',
                                type: "number",
                                "background-color": "bg-white",
                                class: "w-24 text-right text-[0.9rem] font-medium text-primary-800 border border-gray-300 rounded",
                                onKeydown: _ctx.onNumberKeydown,
                                "onUpdate:value": ($event: any) => (_ctx.onRemainderInput(item, $event))
                              }, null, 8, ["value", "onKeydown", "onUpdate:value"])
                            ]),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.getCompoundConsumption(item))), 1)
                          ])
                        ]))
                      : (_ctx.isType1Multi(item))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.hasComponents(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.editLabel')), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium border", _ctx.rowStates[item.feedmix.id].editMode === 'aggregate' ? 'bg-primary-800 text-white border-primary-800' : 'bg-white text-gray-600 border-gray-300']),
                                    onClick: ($event: any) => (_ctx.setEditMode(item.feedmix.id, 'aggregate'))
                                  }, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.editAggregate')), 11, _hoisted_40),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium border", _ctx.rowStates[item.feedmix.id].editMode === 'components' ? 'bg-primary-800 text-white border-primary-800' : 'bg-white text-gray-600 border-gray-300']),
                                    onClick: ($event: any) => (_ctx.setEditMode(item.feedmix.id, 'components'))
                                  }, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.editComponents')), 11, _hoisted_41)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.rowStates[item.feedmix.id]?.componentsModeOverridden)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createVNode(_component_Icon, {
                                    src: _ctx.IconSource.Warning,
                                    class: "w-4 h-4 flex-shrink-0"
                                  }, null, 8, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.componentsModeOverriddenWarning')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_43, [
                              _cache[6] || (_cache[6] = _createElementVNode("span", null, null, -1)),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.registeredConsumptionShort')), 1),
                              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualConsumptionShort')), 1),
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.registeredPriceShort')) + _toDisplayString(_ctx.priceUnitSuffix), 1),
                              _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualPriceShort')) + _toDisplayString(_ctx.priceUnitSuffix), 1),
                              _cache[7] || (_cache[7] = _createElementVNode("span", null, null, -1)),
                              _cache[8] || (_cache[8] = _createElementVNode("span", null, null, -1))
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEffectiveRawMaterials(item), (mat) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: mat.raw_material_id,
                                class: "grid grid-cols-[2fr_1fr_1fr_1fr_1fr_2rem_2rem] items-center gap-x-3 px-6 py-3 bg-gray-50 border-b last:border-b-0 border-gray-100"
                              }, [
                                _createElementVNode("span", _hoisted_48, _toDisplayString(mat.name), 1),
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatNumber(mat.consumption_over_period)), 1),
                                _createElementVNode("div", _hoisted_50, [
                                  (_ctx.canEditRawMat(item))
                                    ? (_openBlock(), _createBlock(_component_SimpleInput, {
                                        key: 0,
                                        grouped: "",
                                        value: _ctx.rowStates[item.feedmix.id].rawActuals[mat.raw_material_id] ?? '',
                                        type: "number",
                                        "background-color": "bg-white",
                                        class: "w-24 text-right text-sm border border-gray-300 rounded",
                                        onKeydown: _ctx.onNumberKeydown,
                                        "onUpdate:value": ($event: any) => (_ctx.rowStates[item.feedmix.id].rawActuals[mat.raw_material_id] = ($event === '' || $event === null ? null : _ctx.toPositive($event)))
                                      }, null, 8, ["value", "onKeydown", "onUpdate:value"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.formatNumber(_ctx.rowStates[item.feedmix.id].rawActuals[mat.raw_material_id] ?? mat.consumption_over_period)), 1))
                                ]),
                                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.formatNumber(mat.price_per_100kg)), 1),
                                _createElementVNode("div", _hoisted_53, [
                                  (_ctx.canEditRawMat(item))
                                    ? (_openBlock(), _createBlock(_component_SimpleInput, {
                                        key: 0,
                                        grouped: "",
                                        value: _ctx.rowStates[item.feedmix.id].rawPrices[mat.raw_material_id] ?? '',
                                        type: "number",
                                        "background-color": "bg-white",
                                        class: "w-24 text-right text-sm border border-gray-300 rounded",
                                        onKeydown: _ctx.onNumberKeydown,
                                        "onUpdate:value": ($event: any) => (_ctx.rowStates[item.feedmix.id].rawPrices[mat.raw_material_id] = ($event === '' || $event === null ? null : _ctx.toPositive($event)))
                                      }, null, 8, ["value", "onKeydown", "onUpdate:value"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_54, "–"))
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("span", null, null, -1)),
                                _cache[10] || (_cache[10] = _createElementVNode("span", null, null, -1))
                              ]))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.registeredPriceShort')) + _toDisplayString(_ctx.priceUnitSuffix), 1),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualPriceShort')) + _toDisplayString(_ctx.priceUnitSuffix), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.registeredEnergyContentShort')) + _toDisplayString(_ctx.energyUnitSuffix), 1),
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.actualEnergyContentShort')) + _toDisplayString(_ctx.energyUnitSuffix), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatNumber(item.price_per_100kg)), 1),
                        _createVNode(_component_SimpleInput, {
                          grouped: "",
                          value: _ctx.rowStates[item.feedmix.id].actualPrice ?? '',
                          type: "number",
                          "background-color": "bg-white",
                          class: "w-24 text-right text-[0.9rem] font-medium text-primary-800 border border-gray-300 rounded",
                          onKeydown: _ctx.onNumberKeydown,
                          "onUpdate:value": ($event: any) => (_ctx.rowStates[item.feedmix.id].actualPrice = ($event === '' || $event === null ? null : _ctx.toPositive($event)))
                        }, null, 8, ["value", "onKeydown", "onUpdate:value"]),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(item.energy_per_100kg !== null && item.energy_per_100kg !== undefined ? _ctx.formatNumber(item.energy_per_100kg) : '–'), 1),
                        _createVNode(_component_SimpleInput, {
                          grouped: "",
                          value: _ctx.rowStates[item.feedmix.id].actualEnergyContent ?? '',
                          type: "number",
                          "background-color": "bg-white",
                          class: "w-24 text-right text-[0.9rem] font-medium text-primary-800 border border-gray-300 rounded",
                          onKeydown: _ctx.onNumberKeydown,
                          "onUpdate:value": ($event: any) => (_ctx.rowStates[item.feedmix.id].actualEnergyContent = ($event === '' || $event === '-' || $event === '.' || $event === ',') ? null : _ctx.toPositive($event))
                        }, null, 8, ["value", "onKeydown", "onUpdate:value"])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.rowStates[item.feedmix.id] && _ctx.rowStates[item.feedmix.id].expanded]
                  ])
                ]))
              }), 128)),
              (_ctx.summary.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.registrationSummary.columns.total')), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, null, -1)),
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.formatNumber(_ctx.totalRegisteredConsumption)), 1),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.formatNumber(_ctx.totalActualConsumption)), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, null, -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_67, [
      (_ctx.reconciliation !== null && _ctx.reconciliation !== undefined)
        ? (_openBlock(), _createBlock(_component_DeleteReconciliationConfirmationModal, {
            key: 0,
            reconciliation: _ctx.reconciliation,
            onDeleted: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('deleted')))
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_DeleteButton, {
                onClick: scope.open
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.feed.reconciliations.editModal.deleteButton')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["reconciliation"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CustomButton, {
        class: "min-w-44 ml-auto",
        disabled: !_ctx.summary || _ctx.loading || _ctx.isSubmitting || _ctx.actualsLoading,
        onClick: _ctx.onSubmitClicked
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.reconciliation !== null && _ctx.reconciliation !== undefined
                    ? _ctx.$t('views.feed.reconciliations.newModal.updateButton')
                    : _ctx.$t('views.feed.reconciliations.newModal.createButton')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}